export * from './core.module';
export * from './services';
export * from './models';
interface Errors {
    errors: {
        [key: string]: string|Error
    };
}
export {Errors};


// WEBPACK FOOTER //
// ./src/app/core/index.ts